<template>
  <li v-if="parentType === 'employee_list'" class="paragraph-employee">
    <EmployeeTeaser :id v-bind="teaserProps" />
  </li>
  <div
    v-else
    class="paragraph-employee"
    :class="{
      container: !parentType,
    }"
  >
    <EmployeeTeaser :id v-bind="teaserProps" />
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphEmployeeFragment } from '#graphql-operations'

const props = defineProps<{
  employee?: ParagraphEmployeeFragment['employee']
}>()

const { index, siblings, parentType, options } = defineBlokkli({
  bundle: 'employee',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    contact: {
      type: 'checkboxes',
      label: 'Contact information',
      default: ['position', 'mail_short', 'linkedin_short'],
      options: {
        position: 'Show position',
        phone_short: 'Show phone icon',
        mail_short: 'Show mail icon',
        linkedin_short: 'Show LinkedIn icon',
        phone_long: 'Show phone number',
        mail_long: 'Show mail address',
        linkedin_long: 'Show Linkedin link',
      },
    },
  },
})

const id = useParagraphAnchorId(index, siblings)

const teaserProps = computed(() => ({
  ...props.employee,
  showPosition: options.value.contact.includes('position'),
  showPhoneShort: options.value.contact.includes('phone_short'),
  showPhoneLong: options.value.contact.includes('phone_long'),
  showMailShort: options.value.contact.includes('mail_short'),
  showMailLong: options.value.contact.includes('mail_long'),
  showLinkedinShort: options.value.contact.includes('linkedin_short'),
  showLinkedinLong: options.value.contact.includes('linkedin_long'),
}))
</script>
